export const DataTable = () => import('./DataTable');